import { useState, useEffect } from "react";
import axios from "../axiosConfig";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Detect user's preferred theme
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    document.documentElement.classList.toggle("dark", prefersDark);

    const checkIfLoggedIn = async () => {
      try {
        const response = await axios.get("/auth/session/verify/"); 
        if (response.status === 200) {
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("User not logged in", error);
      }
    };

    checkIfLoggedIn();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.get("/auth/link/", { 
        params: { email } 
      });
      setMessage(response.data.message);
    } catch (error) {
      console.error("Error:", error);
      setMessage(`Error sending sign-in link: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Finance Talking Portal</h2>
        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
        <p>{message}</p>
      </form>
    </div>
  );
};

export default Login;
